<template>
  <div class="channel-view">
    <div class="channel-header">
      <img class="img-1" :src="channelImg.imgIndex" alt="" />
      <!-- 头部 -->
      <div class="center">
        <div class="header">
          <div class="left">
            <ul>
              <li style="margin: 6px 68px 0 0">
                <img style="height: 20px" src="./images/logo1.png" alt="" />
              </li>
              <li @click="routeChange(null)">
                <span style="color: #fff; font-size: 14px; cursor: pointer"
                  >首页</span
                >
              </li>
              <li
                style="margin-right: 30px; font-weight: 600px; font-size: 14px"
                @click="routeChange(1)"
              >
                <span style="color: #fff; font-size: 14px; cursor: pointer"
                  >钉钉版</span
                >
              </li>
              <li @click="routeChange(2)">
                <span style="color: #fff; font-size: 14px; cursor: pointer"
                  >企业微信版</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="type === 1" class="channel-img-content">
        <h3>精臣云资产钉钉版<br />上线RFID功能</h3>
        <p>秒盘上百个资产</p>
        <div class="primary-btn" @click="handleCounselling">咨询钉钉版</div>
      </div>
      <div v-else class="channel-img-content">
        <!-- <a href="https://open.work.weixin.qq.com" target="_blank">
          <img
            class="service-support"
            src="https://open.work.weixin.qq.com/service/img?id=ww78cdbaf1a5ff313e&t=isp&c=white&s=medium"
            srcset="
              https://open.work.weixin.qq.com/service/img?id=ww78cdbaf1a5ff313e&t=isp&c=white&s=medium@2x 2x
            "
            referrerpolicy="unsafe-url"
            alt="企业微信"
          />
        </a> -->
        <h3>固资管理，用精臣云资产更简单</h3>
        <p>
          精臣云资产成功入驻企业微信<br />
          内外协同，连接你的团队<br />
          实现个人微信、企业微信等
        </p>
        <div class="primary-btn" @click="handleCounselling">咨询企业微信版</div>
        <!-- <div class="wework-install">
          <div class="item">
            <a
              href="https://open.work.weixin.qq.com/wwopen/appUrl/921600"
              target="_blank"
            >
              <img height="35" :src="weInstallImg" />
            </a>
          </div>
          <div class="item">
            <img height="35" :src="registerWeworkImg" @click="registerWework" />
          </div>
        </div> -->
      </div>
    </div>
    <div class="channel-content">
      <img :src="channelImg.img1" alt="" />
      <div v-if="type === 1" class="channel-img-content font-white">
        <h3>打通OA钉钉审批</h3>
        <p>消息同步至钉钉OA，协同更便捷。</p>
      </div>
      <div v-else class="channel-img-content font-white">
        <h3>
          同步企业微信组织架构<br />
          全面提升组织效率
        </h3>
        <p>
          安全可靠的组织通讯录，快速找到同事，<br />
          实现组织架构扁平化、可视化
        </p>
      </div>
    </div>
    <div class="channel-content">
      <img :src="channelImg.img2" alt="" />
      <div
        v-if="type === 1"
        class="channel-img-content font-white content-right"
      >
        <h3>钉钉直连标签打印机</h3>
        <p>无需下载APP，标签随打随贴，操作更简单。</p>
      </div>
      <div v-else class="channel-img-content font-white content-right">
        <h3>
          资产批量录入 资产单据批量打印<br />
          全面提升资产管理效率
        </h3>
        <p>
          全员资产安全盘点，包含固定资产、耗材等，<br />
          实现资产高效协同管理
        </p>
      </div>
    </div>
    <div class="channel-content">
      <img :src="channelImg.img3" alt="" />
      <div v-if="type === 1" class="channel-img-content font-white">
        <h3>资产全生命周期管理</h3>
        <p>从采购到盘点全流程管理，办公更高效。</p>
      </div>
      <div v-else class="channel-img-content font-white">
        <h3>
          待办、企业微信消息及时通知<br />
          全面提升组织效率
        </h3>
        <p>
          系统通知时时推送<br />
          可自定义消息内容，一键处理，方便快捷
        </p>
      </div>
    </div>
    <div class="channel-service">
      <h3>唯一能连接线下打印机的服务商</h3>
      <h4>提供软硬件一体化解决方案</h4>
      <ul>
        <li>
          <img src="./images/channel/service/B32.png" alt="" />
          <p>搭配精臣B32，标签随打随贴</p>
        </li>
        <li>
          <img src="./images/channel/service/one.png" alt="" />
          <p>软硬件一体，灵活易用</p>
        </li>
        <li>
          <img src="./images/channel/service/iclude.png" alt="" />
          <p>阿里云存储，数据安全</p>
        </li>
        <li>
          <img src="./images/channel/service/local.png" alt="" />
          <p>系统对接，本地化部署</p>
        </li>
      </ul>
    </div>
    <div class="channel-icon">
      <h3>30天免费试用</h3>
      <h4>点击页面的"在线咨询"或"安装{{ title }}版"</h4>
      <ul>
        <li>
          <img src="./images/channel/icon/1.png" alt="" />
        </li>
        <li>
          <img src="./images/channel/icon/2.png" alt="" />
        </li>
        <li>
          <img src="./images/channel/icon/3.png" alt="" />
        </li>
        <li>
          <img src="./images/channel/icon/4.png" alt="" />
        </li>
      </ul>
    </div>
    <jc-dialog
      :title="`${title}扫码添加应用`"
      :visible.sync="downVisible"
      v-if="downVisible"
      width="500px"
      height="40vh"
      :show-footer="false"
    >
      <div class="subtitle">
        <h3 v-if="type === 1">扫码后选择组织即可开通应用</h3>
        <img :src="channelImg.openImg" alt="" />
      </div>
    </jc-dialog>
  </div>
</template>

<script>
import imgIndex from './images/channel/dingtalk/index.png'
import img1 from './images/channel/dingtalk/1.png'
import img2 from './images/channel/dingtalk/2.png'
import img3 from './images/channel/dingtalk/3.png'
import weImgIndex from './images/channel/wechat/index.png'
import weImg1 from './images/channel/wechat/1.png'
import weImg2 from './images/channel/wechat/2.png'
import weImg3 from './images/channel/wechat/3.png'
import openImg from './images/channel/dingtalk-open.png'
import weOpenImg from './images/channel/wechat-open.png'
import weInstallImg from './images/channel/install_to_wework.png'
import registerWeworkImg from './images/channel/register_wework.png'
import JcDialog from './dialog/jc-dialog'

export default {
  name: 'channel',
  components: {
    JcDialog,
  },
  props: {
    type: Number,
  },
  data() {
    return {
      downVisible: false,
      weInstallImg,
      registerWeworkImg,
    }
  },
  computed: {
    title() {
      const titleEnum = ['钉钉', '企业微信']
      return titleEnum[this.type - 1]
    },
    channelImg() {
      const typeEnum = [
        {
          imgIndex,
          img1,
          img2,
          img3,
          openImg,
        },
        {
          imgIndex: weImgIndex,
          img1: weImg1,
          img2: weImg2,
          img3: weImg3,
          openImg: weOpenImg,
        },
      ]
      console.log(typeEnum[this.type - 1], this.type)
      return typeEnum[this.type - 1]
    },
  },
  methods: {
    handleCounselling() {
      const url = 'https://affim.baidu.com/unique_39714517/chat?siteId=17955897&userId=39714517&siteToken=a0d1a4ad1ec782711ec76fb358005a0f'
      window.open(url, '_blank')
    },
    routeChange(type) {
      this.$emit('channelChange', type)
    },
    async registerWework() {
      const baseUrl = 'https://yzcweixin.niimbot.com/customer/api'
      try {
        const { data } = await fetch(
          `${baseUrl}/weixin/auth/registerCode`
        ).then((res) => res.json())
        const url = `https://open.work.weixin.qq.com/3rdservice/wework/register?register_code=${data.register_code}#/pc`
        window.open(url, '_blank')
      } catch (e) {
        this.$message.error('出错了，请您稍后再试~')
      }
    },
  },
}
</script>

<style scoped>
.channel-view {
  width: 100%;
  background-color: #fff;
}
.channel-view .channel-header {
  position: relative;
  height: 650px;
  position: relative;
}
.channel-view .channel-header .img-1 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.channel-view .channel-header .center {
  width: 1200px;
  margin: 0 auto;
}
.channel-view .channel-header .header {
  width: 1200px;
  height: 60px;
  line-height: 60px;
  position: absolute;
  z-index: 10;
}
.channel-view .channel-header .header .left ul li {
  float: left;
  margin-right: 32px;
}
.channel-view .channel-header .header .right ul li {
  float: right;
  margin-left: 16px;
}
.channel-view .channel-content {
  width: 100%;
  position: relative;
  font-size: 0;
  /* margin-bottom: 20px; */
}
.channel-view .channel-content img {
  width: 100%;
  margin: 0;
}
.channel-view .channel-img-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  z-index: 1;
  text-align: left;
}
.channel-view .channel-img-content h3 {
  font-size: 36px;
  font-weight: 700;
  color: #1968ff;
}
.channel-view .channel-img-content p {
  color: #52555a;
  font-size: 20px;
  margin: 20px 0;
}
.channel-view .channel-img-content .primary-btn {
  display: inline-block;
  background-color: #1968ff;
  padding: 0 18px;
  height: 36px;
  line-height: 36px;
  border-radius: 18px;
  color: #fff;
  cursor: pointer;
}
.channel-view .font-white h3,
.channel-view .font-white p {
  color: #fff !important;
}
.channel-view .content-right {
  margin-top: 50px;
}
.channel-view .content-right h3,
.channel-view .content-right p {
  text-align: left;
  padding-left: 600px;
}
.channel-view .channel-service,
.channel-view .channel-icon {
  background-color: #f2f4f9;
  padding: 50px;
  text-align: center;
  color: #2878ff;
}
.channel-view .channel-service h3,
.channel-view .channel-icon h3 {
  font-size: 48px;
  font-weight: 700;
}
.channel-view .channel-service h4,
.channel-view .channel-icon h4 {
  font-size: 32px;
  font-weight: 700;
  margin-top: 20px;
}
.channel-view .channel-service ul,
.channel-view .channel-icon ul {
  width: 1200px;
  margin: 50px auto 0 auto;
  display: flex;
  justify-content: space-between;
}
.channel-view .channel-service ul li {
  font-size: 16px;
  color: #52555a;
}
.channel-view .channel-service ul li img {
  width: 150px;
}
.channel-view .channel-icon {
  color: #181819;
  /* margin-top: 20px; */
}
.channel-view .channel-icon ul {
  flex-wrap: wrap;
}
.channel-view .channel-icon ul li {
  width: 50%;
}
.channel-view .channel-icon ul li img {
  width: 250px;
}
.subtitle {
  text-align: center;
}
.wework-install {
  display: flex;
  margin-top: 100px;
}
.wework-install .item {
  padding-right: 50px;
  /* display: flex; */
  /* align-items: bottom; */
}
.wework-install .item .text {
  margin-bottom: 10px;
  font-weight: 500;
}
.wework-install .item img {
  cursor: pointer;
}
.service-support {
  height: 35px;
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/channel.vue